import { DataTable } from "@msuite/ui/table";
import type { OrderStateTransitionList } from "@msuite/utils/types";
import type { QueryKey, RefetchFn } from "@msuite/ui/query";
import { stateTransitionsTableColumns } from "../state-transitions-table-config";

/** Props Interface */
interface StateTransitionsTableProps {
	stateTransitions: OrderStateTransitionList | undefined;
	isLoading: boolean;
	queryKey: QueryKey | undefined;
	refetch: RefetchFn | undefined;
	persistenceKey: `${string}-table`;
	/** Whether to show the level column. A round's own protocol is every row, so it hides it. */
	withLevel?: boolean;
}

/**
 * A protocol, in the order the server returned it — newest first, so the row a reader opens the
 * panel for is the one at the top.
 *
 * Sorting is left on, so the account can be read oldest-first as a narrative when that is the
 * question, and the persisted layout under `persistenceKey` remembers which way the reader
 * prefers.
 */
export function StateTransitionsTable({
	stateTransitions,
	isLoading,
	queryKey,
	refetch,
	persistenceKey,
	withLevel = true,
}: StateTransitionsTableProps) {
	/** Render */
	return (
		<DataTable
			data={stateTransitions}
			columns={stateTransitionsTableColumns}
			queryKey={queryKey}
			isLoading={isLoading}
			refetch={refetch}
			persistenceKey={persistenceKey}
			initialColumnVisibility={{ level: withLevel }}
			menu={null}
		/>
	);
}
